const SEO = {
  openGraph: {
    type: 'website',
    locale: 'pt-BR',
    url: 'https://silvanomarques.vercel.app/',
    site_name: 'Silvano Marques',
  },
  twitter: {
    site: '@site',
    handle: '@handle',
    cardType: 'summary_large_image',
  },
};

export default SEO;
